module.exports = __webpack_public_path__ + "img/back-white.5be6e782.svg";